import React from "react";

export interface PanelState {
  open: boolean;
  data?: {
    id?: string;
    type: PanelType;
    replyingTo?: {
      id: string;
      title: string;
      meaning?: string;
      region: string;
    };
  };
}

export type PanelType = "about" | "poi" | "story-form";

export const initialPanelState: PanelState = {
  open: false
};

export const PanelContext = React.createContext<
  [PanelState, React.Dispatch<React.SetStateAction<PanelState>>]
>([initialPanelState, () => {}]);
